module.exports = __webpack_public_path__ + "static/media/trackingActive.ca2b1d65.svg";